import styled from "styled-components"

const Separator = styled.hr`
  border-color: var(--textDesc);
  border-width: 2px;
  margin: ${props => props.theme.spacing[8]} 0;
  width: 24px;
`

export default Separator
